import React from "react";
import { Link } from "react-router-dom";
import { connect, useSelector } from "react-redux";
import "./NavbarSmall.scss";
import { Badge, Col, Navbar } from "react-bootstrap";
import { UserRole } from "../../Const";

const NavbarSmall = (props) => {
  const userRole =
    useSelector((state) => state.settings.userRole) || UserRole.normal;

  const isActive = (route) => {
    return route == props.url ? "active" : "";
  };

  return (
    <>
      <Col className="sidebar p-lg-0 sidebar-col-sm">
        <Navbar expand="md" className="p-0">
          <Navbar.Toggle aria-controls="sidebar"></Navbar.Toggle>
          <Navbar.Collapse id="sidebar">
            <div className="w-100 vh-100">
              <div>
                <img
                  src="/images/logo.png"
                  width="50"
                  className="brand-img-sm"
                ></img>
              </div>
              <div className="mt-3">
                <ul>
                  <li>
                    <Link
                      to="/dashboard"
                      className={`${isActive("dashboard")} navbar-row-sm`}
                    >
                      <i className="fas fa-tachometer-alt fa-lg navbar-icon-sm"></i>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/bots"
                      className={`${isActive("bots")} navbar-row-sm`}
                    >
                      <i className="fas fa-robot fa-lg navbar-icon-sm"></i>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/deals"
                      className={`${isActive("deals")} navbar-row-sm`}
                    >
                      <i className="fas fa-exchange-alt fa-lg navbar-icon-sm"></i>
                    </Link>
                  </li>

                  <li>
                    <Link
                      to="/portfolio"
                      className={`${isActive("portfolio")} navbar-row-sm`}
                    >
                      <i className="fas fa-chart-pie fa-lg navbar-icon-sm"></i>
                    </Link>
                  </li>
                  <li>
                    <Link
                      to="/marketplace"
                      className={`${isActive("marketplace")} navbar-row-sm`}
                    >
                      <i className="fas fa-shopping-cart fa-lg navbar-icon-sm"></i>
                    </Link>
                  </li>

                  {/* <li>
                    <Link
                      to="/terminal"
                      className={`${isActive("terminal")} navbar-row-sm`}
                    >
                      <i className="fas fa-terminal fa-lg navbar-icon-sm"></i>
                     
                    </Link>
                  </li> */}
                  {/* <li>
                    <Link
                      to="/price-alert"
                      className={`${isActive("price-alert")} navbar-row-sm`}
                    >
                      <i className="fas fa-bell fa-lg navbar-icon-sm"></i>
                    </Link>
                  </li> */}

                 
                </ul>
              </div>
              <div style={{ bottom: "10px", position: "fixed" }}>
                <a href="/affiliate" style={{ textDecoration: "none" }}>
                  <div className="appstore-sm">
                    <i
                      className="fas fa-share-alt text-dark my-1"
                      style={{ fontSize: 24 }}
                    ></i>
                  </div>
                </a>
                <a
                  href="https://play.google.com/store/apps/details?id=capital.novum.stockhero"
                  target="_blank"
                  style={{ textDecoration: "none" }}
                >
                  <div className="appstore-sm">
                    <img src="/images/google.png" width={25} />
                  </div>
                </a>
                <a
                  href="https://apps.apple.com/us/app/stockhero/id1488574255?ls=1"
                  target="_blank"
                  style={{ textDecoration: "none" }}
                >
                  <div className="appstore-sm">
                    <i className="fab fa-apple fa-xl"></i>
                  </div>
                </a>
              </div>
            </div>
          </Navbar.Collapse>
        </Navbar>
        <span className="expand-btn-sm" onClick={props.toggleExpand}>
          <i className="fas fa-angle-right" style={{marginLeft: "2px"}}></i>
        </span>
      </Col>
    </>
  );
};

export default connect(null)(NavbarSmall);
